var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSettings = function SvgSettings(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 10C27.6046 10 28.5 9.10457 28.5 8C28.5 6.89543 27.6046 6 26.5 6C25.3954 6 24.5 6.89543 24.5 8C24.5 9.10457 25.3954 10 26.5 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 18C27.6046 18 28.5 17.1046 28.5 16C28.5 14.8954 27.6046 14 26.5 14C25.3954 14 24.5 14.8954 24.5 16C24.5 17.1046 25.3954 18 26.5 18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26C27.6046 26 28.5 25.1046 28.5 24C28.5 22.8954 27.6046 22 26.5 22C25.3954 22 24.5 22.8954 24.5 24C24.5 25.1046 25.3954 26 26.5 26Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjUgMTBDMjcuNjA0NiAxMCAyOC41IDkuMTA0NTcgMjguNSA4QzI4LjUgNi44OTU0MyAyNy42MDQ2IDYgMjYuNSA2QzI1LjM5NTQgNiAyNC41IDYuODk1NDMgMjQuNSA4QzI0LjUgOS4xMDQ1NyAyNS4zOTU0IDEwIDI2LjUgMTBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjYuNSAxOEMyNy42MDQ2IDE4IDI4LjUgMTcuMTA0NiAyOC41IDE2QzI4LjUgMTQuODk1NCAyNy42MDQ2IDE0IDI2LjUgMTRDMjUuMzk1NCAxNCAyNC41IDE0Ljg5NTQgMjQuNSAxNkMyNC41IDE3LjEwNDYgMjUuMzk1NCAxOCAyNi41IDE4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTI2LjUgMjZDMjcuNjA0NiAyNiAyOC41IDI1LjEwNDYgMjguNSAyNEMyOC41IDIyLjg5NTQgMjcuNjA0NiAyMiAyNi41IDIyQzI1LjM5NTQgMjIgMjQuNSAyMi44OTU0IDI0LjUgMjRDMjQuNSAyNS4xMDQ2IDI1LjM5NTQgMjYgMjYuNSAyNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";